<template>
  <div class="bulk-elimination">
    <div class="header">
      <div class="progress">
        <button v-if="showContinueButton" @click="goToNextStep()" class="button filled accent-1 continue">Continue
        </button>
        <p v-if="showProgressCount">Selected: {{ selectedItems.length }} of {{
            currentRemainder
                                    }}</p>
      </div>
      <button class="button hollow primary view-instructions"
              @click.prevent="this.$parent.showInstructions = true">Instructions
      </button>
    </div>
    <div class="values flex-cols flex-cols-3 sm:flex-cols-4 md:flex-cols-5 lg:flex-cols-6 xl:flex-cols-7">
      <div class="value" v-for="item in items" @click="selectItem(item)" :class="{'is-selected': isSelected(item)}">
        {{ item.name }}
      </div>
    </div>
    <div class="next-step">
      <button v-if="showContinueButton" @click="goToNextStep()" class="button filled accent-1 continue">Continue
      </button>
    </div>

    <div class="message-popover" ref="messagePopover">
      <div class="popover-header">
        <h4 class="popover-title">You have already selected the required amount!</h4>
      </div>
      <div class="popover-body">
        <p>If you would like to revise your selections, click "Edit Selection" below and then click a Value to unselect
           it. Once you unselect a Value, you will be able to make another selection.</p>
        <p>If you are happy with your current selections and understand the last item you clicked will not be included,
           you may click "Continue" to proceed to the next step.</p>
      </div>

      <div class="popover-footer">
        <button @click="hidePopover()" class="button hollow primary continue">Edit Selections</button>
        <button @click="goToNextStep(); hidePopover()" class="button filled accent-1 continue">Continue</button>
      </div>
    </div>
  </div>
</template>


<script>

export default {

  props: {
    allValues:  {
      type: Array
    },
    remainder1: {
      type: Number
    },
    remainder2: {
      type: Number
    },
    remainder3: {
      type: Number
    }
  },

  data() {
    return {
      selectedItems: [],
      items:         this.allValues,
      remainder1Set: false,
      remainder2Set: false,
    };
  },
  mounted() {
    // console.log('Results component mounted')
  },
  computed: {
    currentRemainder() {
      if (this.remainder1Set && this.remainder2Set) {
        return this.remainder3
      } else if (this.remainder1Set) {
        return this.remainder2
      } else {
        return this.remainder1
      }
    },
    showContinueButton() {
      return this.selectedItems.length === this.currentRemainder;
    },
    showProgressCount() {
      return this.selectedItems.length !== this.currentRemainder;
    }
  },
  methods:  {
    showPopover() {
      this.$refs.messagePopover.style.display = "flex";
    },
    hidePopover() {
      this.$refs.messagePopover.style.display = "none";
    },
    goToNextStep() {
      if (this.selectedItems.length === this.remainder1) {
        console.log(this.selectedItems);
        if (this.remainder2) {
          this.items = this.selectedItems;
          this.selectedItems = [];
          this.remainder1Set = true;
        } else {
          this.$parent.remainingValues = this.selectedItems;
          this.$parent.bulkEliminationComplete = true;
        }

      } else if (this.remainder1Set && this.selectedItems.length === this.remainder2) {
        console.log(this.selectedItems);
        if (this.remainder3) {
          this.items = this.selectedItems;
          this.selectedItems = [];
          this.remainder2Set = true;
        } else {
          this.$parent.remainingValues = this.selectedItems;
          this.$parent.bulkEliminationComplete = true;
        }
      } else if (this.remainder2Set && this.selectedItems.length === this.remainder3) {
        console.log(this.selectedItems);
        this.$parent.remainingValues = this.selectedItems;
        this.$parent.bulkEliminationComplete = true;
      }
    },
    getValueDefinition(value) {
      for (let i = 0; i < this.allValues.length; i++) {
        if (this.allValues[i].name === value) {
          return this.allValues[i].definition;
        }
      }
    },
    selectItem(item) {
      let currentlySelected = false;

      for (let i = 0; i < this.selectedItems.length; i++) {

        // If the item is already selected, remove it from the array
        if (this.selectedItems[i].name === item.name) {
          currentlySelected = true;

          // initialize a new array, and add all items except the one to be removed
          // This is done since the delete operator does not update the length of the array,
          // only deletes the value of the index
          let remainingSelectedItems = [];
          for (let j = 0; j < this.selectedItems.length; j++) {
            if (j !== i) {
              remainingSelectedItems.push(this.selectedItems[j]);
            }
          }
          this.selectedItems = remainingSelectedItems;
        }
      }

      if (!currentlySelected) {
        if (this.selectedItems.length === this.currentRemainder) {
          this.showPopover();
        } else {
          this.selectedItems.push(item);
        }

      }
    },
    isSelected(item) {
      for (let i = 0; i < this.selectedItems.length; i++) {
        if (this.selectedItems[i].name === item.name) {
          return true;
        }
      }
    }
  }
}

</script>